// extracted by mini-css-extract-plugin
module.exports = {"header":"search_header__Iar3S","results":"search_results__BCUNG","nothing_found":"search_nothing_found__GPUYe"};